import { ProspectInterest } from "@/enum/prospect.enum";

import { ContactListInfo, ContactListPerson } from "../schema/contacts";

export function getLastListPerson(
	listPersons?: ContactListPerson[]
): ContactListPerson | undefined {
	if (!listPersons?.length) {
		return undefined;
	}

	return [...listPersons].sort(
		(a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
	)[0];
}

export function getSentimentColor(sentiment: ProspectInterest | null): string {
	switch (sentiment) {
		case ProspectInterest.INTERESTED:
			return "bg-status-success-light text-status-success";
		case ProspectInterest.NOT_INTERESTED:
			return "bg-status-error-light text-status-error";
		case ProspectInterest.NEUTRAL:
			return "bg-status-info-light text-status-info";
		case ProspectInterest.BAD_TIMING:
			return "bg-status-warning-light text-status-warning";
		case ProspectInterest.WRONG_PERSON:
			return "bg-status-wrong-person-light text-status-wrong-person";
		default:
			return "bg-gray-100 text-gray-400";
	}
}

export function formatSentimentLabel(sentiment: ProspectInterest | null): string {
	if (!sentiment) {
		return "-";
	}

	return sentiment
		.replaceAll("_", " ")
		.toLowerCase()
		.replace(/\b\w/g, (c) => c.toUpperCase());
}

export function getOriginList(
	listPersons?: ContactListPerson[],
	lists?: ContactListInfo[]
): ContactListInfo | undefined {
	if (!listPersons?.length || !lists?.length) {
		return undefined;
	}

	const withListId = listPersons.filter((lp) => typeof lp.listId === "number");

	if (!withListId.length) {
		return undefined;
	}

	const oldest = [...withListId].sort((a, b) => {
		if (a.createdAt && b.createdAt) {
			return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
		}

		if (a.createdAt) {
			return -1;
		}

		if (b.createdAt) {
			return 1;
		}

		return a.id - b.id;
	})[0];

	return lists.find((l) => l.id === oldest.listId);
}

export function stripHtml(html: string): string {
	const div = document.createElement("div");

	div.innerHTML = html;

	return div.textContent || div.innerText || "";
}
